import { Company, UserInformation } from "@/data/client";
import { AccountInfo } from "@azure/msal-browser";
import { defineStore } from "pinia";

export const useUserStore = defineStore("user", {
  state: () => ({
    userInfo: null as UserInformation | null,
    accountInfo: null as AccountInfo | null,
    accessToken: null as string | null,
    otherEmail: null as string | null,
  }),
  getters: {
    sortedCompanies: (state) => {
      if (!state.userInfo?.companies) return [];
      return [...state.userInfo.companies].sort((a, b) =>
        (a.companyName ?? "").localeCompare(b.companyName ?? "")
      );
    },
  },
  actions: {
    setUserInfo(userData: UserInformation) {
      this.userInfo = userData;
    },
    setAccountInfo(accountData: AccountInfo) {
      this.accountInfo = accountData;
    },
    setAccessToken(token: string) {
      this.accessToken = token;
    },
    setOtherEmail(otherEmail: string | null) {
      if (otherEmail === undefined) {
        this.otherEmail = "";
      } else {
        this.otherEmail = otherEmail;
      }
    },
    setCustomerCompany(customerCompany: Company) {
      if (this.userInfo && customerCompany !== undefined) {
        // console.log(customerCompany);
        const {
          customerAccountNumber,
          companyName,
          accountId,
          samInfo,
          kamInfo,
          artwork,
          currency,
        } = customerCompany;

        this.userInfo = {
          ...this.userInfo,
          customerAccountNumber,
          companyName,

          accountId,
          samInfo,
          kamInfo,
          artwork,
          currency,
        };
      }
    },
  },
});
